class DeferredMedia extends HTMLElement {
    constructor() {
        super(), this.isPlaying = !1;
        let t = this.querySelector('[id^="Deferred-Poster-"]');
        if (!t) return;
        t.addEventListener("click", this.loadContent.bind(this)), this.dataset.autoplay && deferredMediaObserver.observe(this)
    }

    loadContent(t = !0) {
        if (!this.deferredElement) {
            let e = document.createElement("div");
            e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0), this.deferredElement = this.appendChild(e.querySelector("video, model-viewer, iframe"))
        }
        this.deferredElement && (t && this.deferredElement.focus(), "VIDEO" == this.deferredElement.nodeName && this.deferredElement.getAttribute("autoplay") && (this.deferredElement.play(), this.isPlaying = !0))
    }

    pause() {
        this.deferredElement && this.isPlaying && (window.pauseAllMedia(this), this.isPlaying = !1)
    }
}

customElements.define("deferred-media", DeferredMedia);
$(document).ready(function(){
    $('.py-custom-add-cart-center-button').on('click',function(){
        console.log('.py-custom-add-cart-center-button')
        setTimeout(function(){
            cartCenter.cardAlign()
        },900) 
    })
 })